/** Roles that may request client edit/delete (admin must approve). */
export const CLIENT_CHANGE_REQUEST_ROLES = ['manager', 'finance', 'sub_admin'];

export function canRequestClientChanges(user) {
    return !!user && CLIENT_CHANGE_REQUEST_ROLES.includes(user.role);
}

/** Approved client + privileged role — no sales-team link required for finance/manager/sub_admin. */
export function canRequestClientChangeOnSubmission(user, submission) {
    if (!canRequestClientChanges(user) || !submission) return false;
    if (submission.status !== 'approved') return false;
    if (['cancelled', 'refunded'].includes(submission.clientStatus)) return false;
    return true;
}
